import React, { useEffect, useState ,useCallback} from "react";
import { authorizedAPIs } from "../../API/axiosSetup";
import { useParams } from "react-router-dom";
import LinearProgress from "@mui/material/LinearProgress";
import EnhancedTable from "../../components/Table/table";
import { Typography } from "@mui/material";
import { showAlert } from "../../Redux/actions/viewAlert";
import { useDispatch } from "react-redux";

const initialHeadCells = [
  {
    id: "fullName",
    numeric: false,
    label: "الاسم",
  },
  {
    id: "email",
    numeric: false,
    label: "الايميل",
  },
  {
    id: "academicYear",
    numeric: false,
    label: "المرحلة الدراسية",
  },
];

function UsersNotInExercise() {
  const { _id } = useParams();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const rowsPerPageOptions = [ 5, 10, 25, 50, 100, 150, 200, 250, 300]
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[0]);
  const [page, setPage] = useState(0);
  const [numberOfSpecialStudent, setNumberOfSpecialStudent] = useState()

  const getStudentForAllowExercise = useCallback(() => {
    const skip = (page) * rowsPerPage;

    authorizedAPIs
      .get(`/exercises/admin/getStudentForAllowExercise/${_id}?limit=${rowsPerPage}&skip=${skip}`)
      .then((res) => {
        setUsers(res.data.result);
        setNumberOfSpecialStudent(res.data.numberOfSpecialStudent)
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err.message);
        setIsLoading(false);
      });
  }, [_id,page,rowsPerPage]);

  useEffect(() => {
    getStudentForAllowExercise();
  }, [_id,page,rowsPerPage]);

  const addToExercise = (users_ids) => {
    authorizedAPIs
      .put(`/exercises/admin/allowExercise/${_id}`, { users_ids })
      .then((res) => {
        getStudentForAllowExercise();
        dispatch(showAlert("تم اضافة التمرين بنجاح", "success"));
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  


  return (
    <div>
      {isLoading ? (
        <LinearProgress />
      ) : (
        <>
         <Typography
        style={{ fontSize: "30px", color: "#010004", textAlign: "center" }}
      >
        أختار طالب لاضافة تمرين له
      </Typography>
        <EnhancedTable
          withEdit={false}
          withConfirm
          manyAction={addToExercise}
          manyActionLabel={"add"}
          initialRows={users}
          headCells={initialHeadCells}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          rowsPerPageOptions={rowsPerPageOptions}
          page={page}
          setPage={setPage}
          count={numberOfSpecialStudent}
          path={"/users/"}
        />
        </>
      )}
    </div>
  );
}

export default UsersNotInExercise;
